import { ComponentType, FC, PropsWithChildren } from 'react';
import { SvgIconProps } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


type Props = PropsWithChildren<{
  title: string
  subtitle: string
  helperText?: string
  icon: ComponentType<SvgIconProps>
}>

export const Section: FC<Props> = ({ title, subtitle, helperText, icon: Icon, children }) => {
  return (
    <Box p={2.5} bgcolor="white" border="1px solid #e5e0dc" borderRadius="12px">
      <Stack gap={2} direction="row">
        <div>
          <Box p={1.75} fontSize={20} lineHeight={0.675} color="#dd765f" bgcolor="rgba(221, 118, 95, 0.1)" borderRadius="50%">
            <Icon fontSize="inherit"/>
          </Box>
        </div>
        <Box flexGrow={1}>
          {helperText && (
            <Typography color="textDisabled">{helperText}</Typography>
          )}
          <Stack gap={0.75}>
            <Typography fontWeight={600}>{title}</Typography>
            <Typography color="textSecondary">{subtitle}</Typography>
            {children}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
